import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-24 px-6 bg-dark relative overflow-hidden" data-id="element-134">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-radial-wine opacity-30 pointer-events-none" data-id="element-135"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="border-l-2 border-wine pl-8 md:pl-12" data-id="element-137">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-8" data-id="element-138">
            El Problema:{' '}
            <span className="text-wine-light italic" data-id="element-139">Tu Armadura de Éxito</span>
          </h2>

          <div className="space-y-6 font-sans text-lg text-cream/80 font-light leading-relaxed" data-id="element-140">
            <p data-id="element-141">
              El problema no es tu apariencia. El problema es tu "Armadura de
              Éxito". Has pasado años entrenando tu cuerpo para sobrevivir en el
              mundo profesional: hombros tensos, mirada de alerta, movimientos
              rápidos y una postura de "no te necesito".
            </p>
            <p data-id="element-142">
              Bio-lógicamente, estás emitiendo una señal de combate. Estás
              proyectando una energía masculina que compite con los hombres que
              quieres atraer.
            </p>
            <p className="text-cream font-medium" data-id="element-143">
              Para un hombre proveedor y seguro, tu lenguaje corporal actual
              dice: "Aléjate, soy una amenaza o soy indiferente".
            </p>
            <p data-id="element-144">
              Estás atrapada en la trampa de la mujer invisible, siendo
              demasiado intimidante para los buenos hombres y un blanco fácil
              para los hombres mediocres.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}